import React from 'react';

const About = () => {
    return (
        <div>
            <h2>All about us</h2>
        </div>
    );
};

export default About;